import { IDoorTotalDelta, IDoorTotals } from "reducers/collection";

export const convertDeltaOperationsForFilteredTotals = (
    deltaOperations: IDoorTotalDelta[],
    doorTotalsFiltered: IDoorTotals
): IDoorTotalDelta[] =>
    deltaOperations
        .map((op) => {
            if (!(op.door in doorTotalsFiltered)) {
                return;
            }
            return op;
        })
        .filter((op) => !!op);
